module.exports = __webpack_public_path__ + "static/media/IconDownUp.d4afc15b.svg";